export const environment = {
  production: false,
  AUTH0_DOMAIN: 'https://ingka-icow-stag.eu.auth0.com',
  AUTH0_CLIENT_ID: 'mxMopbahIiDasDeYQ5HZQAFauRY03fzK',
  AUTH0_AUDIENCE: 'https://ingka-icow-stag.eu.auth0.com/api/v2/',
  TOKEN_GROUPS: 'https://accounts.ikea.com/groups',
  SWIPE_MARKETS: ['ALL'],
  PURCHASE_MARKETS: ['ALL'],
  SIMPLE_SIGNUP_MARKETS: ['ALL'],
  PURCHASE_AND_SIMPLE_SIGNUP_MARKETS: ['ALL'],
  // Requires the lottery template to contain the module 'email-marketing-constraint'
  REQUIRE_EMAIL_MARKETING_CONSTRAINT: ['KR'],
  MINIMUM_PURCHASE_AMOUNT: ['ALL'],
  ikeaDomain: 'www.cte.ikeadt.com',
  customerAdminDomain: 'customeradmin.test.customer.ingka.com',
};
